var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid full-width-page-wrapper"},[(_vm.busy)?_c('ifac-loader'):(_vm.error)?_c('base-error'):(_vm.conference)?_c('ifac-conference-public-display',{attrs:{"conference":_vm.conference,"open-committee":_vm.openCommittee},on:{"committee-change":_vm.onCommitteeChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }